import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { I18n } from 'aws-amplify';
import { fetchAccountLicenses } from '../../components/util/callApi.js';
import { SOLAR_PRO_LICENSE_NAME } from '../../configures/val.js';
import Button from '../../components/common/Button/index.js';
import styles from './styles.module.css';

const defaultLicenses = [];

/**
 * ライセンス管理画面
 * @param {Object} props
 * @param {Function} props.updateHeader - ヘッダの更新メソッド
 * @param {number|undefined} props.accountId - アカウント ID
 * @returns {JSX.Element}
 */
const LicenseManagement = ({ updateHeader, accountId }) => {
  const updateHeaderRef = useRef(updateHeader);

  const [isLoading, setIsLoading] = useState(true);
  const [licenses, setLicenses] = useState(defaultLicenses);

  /**
   * Solar Pro ライセンスの数
   */
  const solarProLicenseCount = useMemo(() => {
    if (!licenses) return;
    return licenses.filter(({ name }) => name === SOLAR_PRO_LICENSE_NAME).length;
  }, [licenses]);

  const loadLicenses = useCallback(async () => {
    if (typeof accountId !== 'number') return;

    try {
      let fetchAccountLicensesRes = await fetchAccountLicenses(accountId);
      if (!fetchAccountLicensesRes.ok) return setLicenses(defaultLicenses);
      const { licenseCount } = fetchAccountLicensesRes.data;
      fetchAccountLicensesRes = await fetchAccountLicenses(accountId, 1, licenseCount);
      setLicenses(
        fetchAccountLicensesRes.ok ? fetchAccountLicensesRes.data.licenses : defaultLicenses
      );
    } catch (error) {
      console.error('Failed to fetch account licenses data', error);
    }

    setIsLoading(false);
  }, [accountId]);

  // ヘッダを更新する
  useEffect(() => {
    if (updateHeaderRef.current) updateHeaderRef.current();
  }, []);

  // ライセンスを取得し状態変数にセットする
  useEffect(() => {
    loadLicenses();
  }, [loadLicenses]);

  if (isLoading) return <>{I18n.get('Now loading...')}</>;

  return (
    <div className={styles.container}>
      {licenses.length > 0 ? (
        <div className={styles.panelArea}>
          <div className={styles.panel}>
            <div className={styles.textArea}>
              <div className={styles.productNameArea}>
                <p>{I18n.get('Product')}</p>
                <p>{`Solar Pro ${I18n.get('Network Authentication Edition')}`}</p>
              </div>
              <div className={styles.licenseCountArea}>
                <p>{I18n.get('License Key')}</p>
                <p>{solarProLicenseCount}</p>
              </div>
            </div>
            <div className={styles.linkBtnArea}>
              <Button
                type='link'
                text={I18n.get('Open')}
                size='small'
                linkTo='/management/license/solarpro'
              />
            </div>
          </div>
        </div>
      ) : (
        <p>{I18n.get('No license.')}</p>
      )}
    </div>
  );
};

export default LicenseManagement;
